import { useCountry } from "@/contexts/CountryContext";

/**
 * Small banner shown above a filtered list.
 *
 * Two states:
 * 1. Matches found → "Showing N of M items in Country".
 * 2. No matches in country → informs the user we're showing global content
 *    so their page isn't blank. Pass `fallback` (from `useCountryFilter` —
 *    it sets `.fallback = true` on the returned array when it falls back).
 */
export default function CountryFilterBanner({ shown, total, fallback = false, noun = "items" }) {
  const { country, clear } = useCountry();
  if (!country) return null;
  return (
    <div
      className="mt-4 flex items-center gap-3 flex-wrap text-xs font-mono rounded-lg border px-3 py-2"
      style={{ borderColor: "var(--wofy-border)", color: "var(--wofy-text-soft)", background: "var(--wofy-surface)" }}
      data-testid="country-filter-banner"
    >
      {fallback ? (
        <span>
          No {noun} in <strong>{country.name}</strong> yet — showing <strong>{total}</strong> {noun} from around the world.
        </span>
      ) : (
        <span>
          Showing <strong>{shown}</strong> of {total} {noun} in <strong>{country.name}</strong>.
        </span>
      )}
      <button onClick={clear} className="underline hover:opacity-80" data-testid="country-filter-clear">
        Show all countries
      </button>
    </div>
  );
}
